export default __webpack_public_path__ + "static/media/thumbnail_blog_20.dff3cef4.jpg";